// extracted by mini-css-extract-plugin
export default {"menuIcon":"JF__IWASHcoIgfrBT8nX"};